module.exports = __webpack_public_path__ + "img/transom.733ee22.svg";